import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/pages/NotFound'
import PageForChina from '@/pages/PageForChina'
import FrameWithBack from '@/pages/help/FrameWithBack'
import Privacy from '@/pages/help/Privacy_202312.vue'
import KidsPrivacy from '@/pages/help/KidsPrivacy_202312.vue'
/*
import Home from '@/pages/home/Home'
import Redirect from '@/pages/Redirect'
import Signin from '@/pages/account/Signin'
import SigninEmail from '@/pages/account/SigninEmail'
import SignupEmail from '@/pages/account/SignupEmail'
import Signout from '@/pages/account/Signout'
import Recover from '@/pages/account/Recover'
import SignupAgreement from '@/pages/account/SignupAgreement'
import Report from '@/pages/report/Report'
import MyPage from '@/pages/mypage/MyPage'
import Membership from '@/pages/membership/Membership'
import Payment from '@/pages/payment/Payment'
import Privacy from '@/pages/payment/Privacy'
import Agreement from '@/pages/payment/Agreement'
import Help from '@/pages/help/Help'
import HelpInApp from '@/pages/help/HelpInApp'
*/
// import { store } from '@/store'

Vue.use(Router);
/*
const requireAuth = () => (to, from, next) => {
	if (to.query.accountid != undefined) {
		next(true);
	} else if (store.getters.isSignedIn) {
		next(true);
	} else {
		const encodedPath = encodeURIComponent(to.fullPath);
		next('/signin?redirect=' + encodedPath);
	}
}
*/

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '*',
			name: 'NotFoundPage',
			component: NotFound
		},
		{
			path: '/cn', redirect: '/cn/faq'
		},
		{
			path: '/cn/:section',
			name: 'pageforchina',
			component: PageForChina,
			props: true
		},
        {
			path: '/cn/privacy/android',
			name: 'Privacy',
			component: Privacy,
		},
        {
			path: '/cn/privacy/kids',
			name: 'KidsPrivacy',
			component: KidsPrivacy,
		},
		{
			path: '/frame/:page',
			name: 'frame',
			component: FrameWithBack,
			props: true
		}
	],
})



// WEBPACK FOOTER //
// ./src/router/index.js